import Topic from "../Topic";

export default function TopicItem({ data }) {
  return <Topic topic={data} />;
}
